
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'dataSource': '数据源',
	'dataSourceId': '标识',
	'dataSourceType': '类型',
	'dataSourceName': '名称',
	'dataSourcePath': '路径',
	'showInfoForAll': '显示所有可视化的持续时间',
	'hideInfoForAll': '隐藏所有可视化的持续时间',
	'showPerformanceDetails': '重新运行所有窗口小部件以包含性能详细信息',
	'slotMappingField': '槽映射',
	'slotDataMapping': '映射',
	'slotID': '标识',
	'slotCaption': '标题',
	'slotMandatory': '必填',
	'slotIsMandatory': '是',
	'slotIsNotMandatory': '否',
	'infoNotAvailable': '不可用',
	'performanceSection': '性能',
	'durationField': '持续时间',
	'singleQueryTime': '服务器查询（毫秒）',
	'multipleQueryTime': '服务器查询 %{name}（毫秒）',
	'liveWidgetTotalTime': '总时间（毫秒）',
	'renderTimeNotAvailable': '不可用',
	'renderInProgress': '（正在进行中）',
	'interactToTriggerQuery': '与窗口小部件交互以触发查询',
	'fetchQuery': '访存查询',
	'showSQLMDX': '显示 SQL/MDX',
	'SQLMDX': 'SQL/MDX',
	'queryInfo': '查询信息',
	'queryInfoNotAvailable': '查询信息不可用',
	'query': '查询',
	'copy': '复制',
	'close': '关闭'
});
